import { Link } from 'react-router-dom';
import logoWhite from '../../../shared/assets/logo/liftpeak_white.png';
import { SocialLinks } from '../../../shared/ui';
import './Footer.css';

interface FooterProps {
  onSocialClick?: () => void;
}

export function Footer({ onSocialClick }: FooterProps) {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={logoWhite} alt="Liftpeak" className="footer-logo-img" />
        </div>

        <div className="footer-links">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms & Conditions</Link>
        </div>

        <SocialLinks onSocialClick={onSocialClick} />
      </div>
    </footer>
  );
}

export default Footer;


